
    <kv-datatable
        *ngIf="activeView == 'list'"
        [allowsMultiSelection]="false"
        id="dt_classification"
        sectionTitle="{{ 'common.classification_title' | translate }}"
        listTitle="{{ 'common.list_title' | translate }}"
        [numRowsPerPage]="10"
        [titles]="titles"
        [items]="this.svc.list"
        deleteButton="{{ 'common.delete' | translate }}"
        editButton="{{ 'common.edit' | translate }}"
        addButton="{{ 'common.add' | translate }}"
        (onAdd)="showAddOrEditDialog($event)"
        (onEdit)="showAddOrEditDialog($event)"
        (onDelete)="delete($event)"
        (onCancelDetail)="this.svc.editing=null"
        [customButtons]="customButtons"
        (onCustomButton)="onCustomButton($event)"
        (onItemClick)="onItemClick($event)"

    >
      <app-classification-form
          *ngIf="this.svc.editing"
          [editingElement]="this.svc.editing"
          (onUpdateElement)="onUpdateElement($event)"
          (onAddElement)="onAddElement($event)"
      ></app-classification-form>
    </kv-datatable>
    <app-kv-classification-types
        *ngIf="activeView =='types'"
        (onBackClick)="reloadList()"
    ></app-kv-classification-types>
    <app-classification-details
        *ngIf="activeView == 'details'"
        (onBackClick)="reloadList()"
    ></app-classification-details>
  


// WEBPACK FOOTER //
// ./src/app/views/administration/classification/classification.component.ts.Classification2Component.html